'use strict';

(() => {
  function updateUntranslatedLinks() {
    const MAX_UPDATE_ATTEMPS = 5;
    const UPDATE_INTERVAL = 1000;

    const mainOrigin = 'https://www.a-vos-trousses.fr';
    if (mainOrigin === window.location.origin) return;

    const alternateMainOrigin = mainOrigin.split('www.').pop();
    const alternateCurrentOrigin = window.location.origin.split('www.').pop();

    function updateLink(link) {
      const href = link.getAttribute('href');
      if (href.includes(mainOrigin)) {
        link.setAttribute(
          'href',
          href.replace(mainOrigin, window.location.origin)
        );
      } else if (href.includes(alternateMainOrigin)) {
        link.setAttribute(
          'href',
          href.replace(alternateMainOrigin, alternateCurrentOrigin)
        );
      }
    }

    let updateAttemps = 0;
    const updateInterval = setInterval(() => {
      updateAttemps++;
      if (updateAttemps >= MAX_UPDATE_ATTEMPS)
        return clearInterval(updateInterval);

      try {
        const untranslatedLinks = Array.from(
          document.querySelectorAll(
            `[href*="${mainOrigin}"], [href*="${alternateMainOrigin}"]`
          )
        );
        if (untranslatedLinks.length === 0) return;

        untranslatedLinks.forEach(updateLink);
      } catch (error) {
        console.error('Error while updating untranslated links', error);
      }
    }, UPDATE_INTERVAL);
  }
  updateUntranslatedLinks();
})();
